import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dates from './utils/dates';
import { accessor as get } from './utils/accessors';
import CellEvent from './CellEvent';

class EventCell extends Component {
  static propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    event: PropTypes.object,
    selected: PropTypes.bool,
    eventPropGetter: PropTypes.string,
    startAccessor: PropTypes.string,
    endAccessor: PropTypes.string,
    titleAccessor: PropTypes.string,
    allDayAccessor: PropTypes.string,
    slotStart: PropTypes.object,
    slotEnd: PropTypes.object,
    onSelect: PropTypes.func,
    component: PropTypes.any,
  };

  render() {
    const {
      style,
      className,
      event,
      selected,
      eventPropGetter,
      startAccessor,
      endAccessor,
      titleAccessor,
      slotStart,
      slotEnd,
      component,
      allDayAccessor,
      onSelect,
    } = this.props;

    const title = get(event, titleAccessor);
    const end = get(event, endAccessor);
    const start = get(event, startAccessor);
    const isAllDay = get(event, allDayAccessor);
    const continuesPrior = dates.lt(start, slotStart, 'day');
    const continuesAfter = dates.gt(end, slotEnd, 'day');

    let xStyle;
    let xClassName;
    if (eventPropGetter) {
      const eventProps = eventPropGetter(event, start, end, selected);
      xStyle = eventProps.style;
      xClassName = eventProps.className;
    }

    return (
      <CellEvent
        event={event}
        style={{ ...style, ...xStyle }}
        title={title}
        className={className}
        xClassName={xClassName}
        selected={selected}
        start={start}
        end={end}
        isAllDay={isAllDay}
        continuesPrior={continuesPrior}
        continuesAfter={continuesAfter}
        handleClick={() => onSelect(event)}
        Component={component}
      />
    );
  }
}

export default EventCell;
